import styled from "@emotion/styled";

export const MarketingMaterialsSearchContainer = styled.div(({ theme }) => ({
	border: theme.project.borders.presets.outline,
	borderWidth: "1px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: 16,
	margin: "16px 24px",
	span: {
		fontSize: "12px",
		fontWeight: 400,
		color: theme.project.colors.fontColors.secondary,
		letterSpacing: "0.4px"
	}
}));

export const MarketingMaterialsSearchInputLine = styled.div(({ theme }) => ({
	display: "grid",
	gap: 8,
	gridTemplateColumns: "auto max-content",
	gridTemplateRows: "40px auto",
	marginRight: "20px",
	width: "100%",
	[theme.breakpoints.down("lg")]: {
		display: "flex",
		flexDirection: "column",
		gap: 16
	}
}));
